import React, { ReactElement } from 'react';
import { Box, Checkbox, Typography } from '@mui/material';
import { getDisplayName } from '../../utils';
import { Device } from '../../generated/graphql';

export interface SelectDeviceItemProps {
  value: Device;
  selected?: boolean;
}

export function DeviceMenuItem({
  selected,
  value,
}: Readonly<SelectDeviceItemProps>): ReactElement<SelectDeviceItemProps> {
  return (
    <>
      <Checkbox color="primary" checked={selected} />
      <Box sx={{ display: 'flex', flexDirection: 'column' }} data-testid={value.name}>
        <Typography variant="body4">{getDisplayName(value)}</Typography>
        {value.externalName && (
          <Typography variant="body2" color={(theme) => theme.palette.grey[300]}>
            {value.name}
          </Typography>
        )}
      </Box>
    </>
  );
}
